<template>
  <div class="mobile-tasks-card">
    <img src="/images/promo/connect-features/mobile-tasks-card.svg" alt="Tasks card" />
  </div>
</template>

<script>
export default {};
</script>
